import { Set } from 'immutable'
import { CategoriesFilter } from '../filtersUtils'

export type CategoriesFilterState = Set<string>

export const initialCategoriesFilterState = (filter: CategoriesFilter) =>
  Set<string>(filter.category ? [filter.category] : [])
